import {color} from 'd3';
import React from 'react';

import getTestProps from 'test/lib/cypress/getTestProps';

interface ModifiedBaseProps {
  cx?: number;
  cy?: number;
  fill: string;
  radius: number;
}

export default function ModifiedBase({cx = 0, cy = 0, fill, radius}: ModifiedBaseProps): JSX.Element {
  const parsedFillColor = color(fill);
  const opacity = parsedFillColor?.opacity ?? 1;
  const fillColor = parsedFillColor?.hex() ?? fill;
  return (
    <circle
      className="modifiedBase"
      cx={cx}
      cy={cy}
      fill={fillColor}
      fillOpacity={opacity}
      r={radius}
      shapeRendering="geometricPrecision"
      {...getTestProps({component: 'ModifiedBase', element: 'root'})}
    />
  );
}
